import React from 'react';
import { connect } from 'react-redux';
import agent from '../../agent';
import { Link } from 'react-router-dom';
import ArtistTable from './ArtistTable';
import ArtistForm from './ArtistForm';

const mapDispatchToProps = dispatch => {
  agent.Artists.all(dispatch);
  agent.Mediums.all(dispatch);
  return {}
};

const mapStateToProps = state => ({
  ...state.currentArtist,
  ...state.artists,
  ...state.mediums
});

const styles = {
  li: {
    listStyle: "none"
  },
  link: {
    color: '#A0A0A0',
    fontSize: '14px',
    textDecoration: 'none',
    fontWeight: '300'
  },
  ul: {
    padding: '0'
  }
}

class Admin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      artist: {},
    }
  }

  render() {
    if(!this.props.artists) return null;

    return (
      <ArtistTable artists={this.props.artists} mediums={this.props.mediums} />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin);



// WEBPACK FOOTER //
// ./src/components/Admin/index.js